import { jwtDecode } from 'jwt-decode';
import Cookies from 'js-cookie';
import {
  ACCESS_TOKEN,
  AUTHENTICATION_USER_ROLES,
  REFRESH_TOKEN,
} from '@shared/const';
import { removeAuthCookies } from '@shared/utils';
import { CognitoTokenUser, KeycloakUserToken } from './api/types';

function isKeycloakUserToken(
  u: CognitoTokenUser | KeycloakUserToken
): u is KeycloakUserToken {
  return (u as KeycloakUserToken).realm_access !== undefined;
}

export type MappedUser = {
  firstName: string;
  lastName: string;
  username: string;
  mobile: string;
  phone_number: string;
  email: string;
  isEmailVerified?: boolean;
  roles: string;
};

export const mapTokenToUser = (token: string): MappedUser => {
  const user = jwtDecode<CognitoTokenUser | KeycloakUserToken>(token);

  if (isKeycloakUserToken(user)) {
    return {
      firstName: user?.given_name,
      lastName: user?.family_name,
      username: user?.preferred_username,
      mobile: user?.phone_number ?? '',
      phone_number: user?.phone_number ?? '',
      email: user?.email,
      isEmailVerified: user?.email_verified,
      roles: user?.realm_access.roles.join(','),
    };
  }

  return {
    firstName: user?.['custom:first_name'],
    lastName: user?.['custom:last_name'],
    username: user?.['cognito:username'],
    mobile: user?.['custom:mobile'],
    phone_number: user?.phone_number,
    email: user?.email,
    isEmailVerified: user?.email_verified,
    roles: user?.['custom:roles'],
  };
};

export const setAuthCookies = (
  token: string,
  refreshToken?: string
) => {
  removeAuthCookies();

  const cookieAttributes = { domain: COOKIE_SUBDOMAIN };

  Cookies.set(
    AUTHENTICATION_USER_ROLES,
    ['broker', 'sales']?.join(','),
    cookieAttributes
  );
  Cookies.set(ACCESS_TOKEN, token, cookieAttributes);
  if (refreshToken) {
    Cookies.set(REFRESH_TOKEN, refreshToken, cookieAttributes);
  }
};

export const setLocalStorageDataForAccountAndChat = (
  tokenUserInfo: MappedUser
) => {
  // set localstorage data (for chat service && Account Settings)
  localStorage.setItem('huspyUserFirstName', tokenUserInfo.firstName);
  localStorage.setItem('huspyUserLastName', tokenUserInfo.lastName);
  localStorage.setItem('huspyUserMobile', tokenUserInfo.mobile);
  localStorage.setItem(
    'huspyUserName',
    `${tokenUserInfo.firstName} ${tokenUserInfo.lastName}`
  );
  localStorage.setItem('huspyUserEmail', tokenUserInfo.email);
};
